const VARIANT_SUCCESS = 'success';
const VARIANT_ERROR = 'error';
const VARIANT_INFO = 'info';
const VARIANT_WARNING = 'warning';
const VARIANT_DISABLED = 'disabled';

const ON_CLOSE_REASON_CLICKAWAY = 'clickaway';

export {
    VARIANT_SUCCESS,
    VARIANT_ERROR,
    VARIANT_INFO,
    VARIANT_WARNING,
    VARIANT_DISABLED,
    ON_CLOSE_REASON_CLICKAWAY,
};
